import { render, staticRenderFns } from "./AppMarkdown.vue?vue&type=template&id=21169fa6&"
import script from "./AppMarkdown.vue?vue&type=script&lang=js&"
export * from "./AppMarkdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports